<template>
  <div class="form-item-wrap" v-if="item?.id" :class="{'error': showError}">
    <p class="form-title" v-if="['info', 'checkbox'].indexOf(item.type) === -1">
      {{ item.name }}
      <span v-if="item.required" class="require">*</span>
      <span v-if="item?.limit_count && (item.limit_count.min || item.limit_count.max)" class="limit-count">
        [ {{ limitCountText(item) }} ]
      </span>
    </p>
    <div class="form-desc" v-html="item.remind">
    </div>
    <div class="form-control">
      <!-- 【0】表单项渲染 -->
      <TextInput 
        v-if="(item.type === 'text' && item.style === 'input') || item.type === 'phone' || item.type === 'weixin' || item.type === 'email' || item.type === 'invite_code'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <Textarea
        v-if="item.type === 'text' && item.style === 'textarea'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <SelectRadio
        v-if="item.type === 'select' && item.style === 'radio' && item.preset !== 'country_region'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <SelectDropdown
        v-if="item.type === 'select' && (item.style === 'dropdown' || item.preset === 'country_region')"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <SelectMulti
        v-if="item.type === 'multi_select'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <ImageUpload
        v-if="item.type === 'image_upload'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <GetLocation
        v-if="item.type === 'location'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <DateSelect
        v-if="item.type === 'date'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <ScoreSelect
        v-if="item.type === 'score'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <MatrixSelect
        v-if="item.type === 'matrix_select'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <CheckboxText
        v-if="item.type === 'checkbox'"
        ref="formItemRef"
        :item="item"
        :submitValue="submitValues[item.id]"
        :readonly="readonly"
        @change="onValueChange($event)"
      />
      <div 
        v-if="item.type === 'info'"
        class="info-text" 
        v-html="$filters.proxyWeixinImage(item.text)"
      ></div>
    </div>
    <div
      v-if="verificateText" 
      class="verificate-control">
      {{ verificateText }}
    </div>
    <transition name="fade">
      <div 
        v-if="showError"
        class="error-bg"
      >
      </div>
    </transition>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { limitCountText, getVerificateText } from './verificate.js';
import TextInput from './TextInput.vue';
import Textarea from './Textarea.vue';
import SelectRadio from './SelectRadio.vue';
import SelectDropdown from './SelectDropdown.vue';
import SelectMulti from './SelectMulti.vue';
import ImageUpload from './ImageUpload.vue';
import GetLocation from './GetLocation.vue';
import DateSelect from './DateSelect.vue';
import ScoreSelect from './ScoreSelect.vue';
import MatrixSelect from './MatrixSelect.vue';
import CheckboxText from './CheckboxText.vue';

export default {
  props: {
    item: Object,
    submitValues: Object,
    readonly: Boolean
  },
  emits: ['val-change'],
  data() {
    return {
      itemValue: null,
      showError: false,
      isChange: false,
    };
  },
  computed: {
    verificateText() {
      return this.isChange ? getVerificateText(this.item, this.submitValues[this.item.id]?.value) : '';
    }
  },
  components: {
    TextInput,
    Textarea,
    SelectRadio,
    SelectDropdown,
    SelectMulti,
    ImageUpload,
    GetLocation,
    DateSelect,
    ScoreSelect,
    MatrixSelect,
    CheckboxText
  },
  methods: {
    limitCountText(item) {
      return limitCountText(item);
    },
    verificate() {
      if (this.$refs['formItemRef']) {
        this.$refs['formItemRef'].onValueChange();
      }
      if (this.verificateText) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 500);
        if (this.item.type === 'checkbox') {
          Toast(`请勾选此项`);
        }
        return false;
      }
      return true;
    },
    onValueChange(e) {
      this.isChange = true;
      this.$emit('val-change', e);
    }
  },
  created() {
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.form-item-wrap {
  margin-bottom: 32px;
  position: relative;

  .form-title {
    font-weight: 700;
    font-size: @font-size-3;
    line-height: 20px;
    color: @title-color;
    margin-bottom: 6px;
    .require {
      color: #d61313;
    }
    .limit-count {
      margin-left: 8px;
      color: @desc-color-2;
      font-weight: 400;
      font-size: @font-size-3;
    }
  }
  .form-desc {
    font-size: @font-size-3;
    line-height: 22px;
    color: @desc-color-2;
    margin-bottom: 12px;
    white-space: pre-line;
  }
  .error-bg {
    position: absolute;
    top: -10px;
    left: -10px;
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    background-color: rgba(214, 19, 19, 0.2);
    border-radius: 4px;
  }
}
.form-control {
  .info-text {
    .form-item-text-1();
    color: @desc-color-1;
    /deep/ img {
      max-width: 100%;
    }
  }
}
.verificate-control {
  .form-item-text-1();
  color: #D61313;
  margin-top: 4px;
}
</style>
